import React, { useState, useEffect } from 'react';
import './HomePageLoader.css'; // Creeremo questo CSS dedicato

/**
 * Mostra il loader personalizzato per la homepage.
 * @param {boolean} show - Controlla la visibilità.
 * @param {string} siteName - Il nome del sito da mostrare.
 */
const HomePageLoader = ({ show, siteName }) => {
  const [isMounted, setIsMounted] = useState(show);
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    if (show) {
      setIsMounted(true);
      setIsHiding(false);
    } else {
      setIsHiding(true);
      const timer = setTimeout(() => {
        setIsMounted(false);
      }, 500); // Durata del fade-out (0.5s)

      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!isMounted) {
    return null;
  }

  return (
    <div className={`homepage-loader-overlay ${isHiding ? 'hiding' : ''}`}>
      <div className="homepage-loader-content">
        <div className="spinner-container"></div>
        <h2 className="loader-sitename">{siteName}</h2>
      </div>
    </div>
  );
};

export default HomePageLoader;